import React, { ReactElement } from 'react';
import './RecallButton.scss';
import { CTA, Text, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import { useTranslation } from 'react-i18next';
import { Lock, UsedCarPrivate } from '@volkswagen-onehub/icons-core';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { DataRequestState } from '../../models/DataRequestState';

export default function RecallButton(props: Props) {
	const { numberRecalls, recallRequestStatus, toggleRecallsLayer } = props;
	const { t } = useTranslation('ns1', { useSuspense: false });

	const lockedContent = () => {
		return (
			<div className="height-thirty-two">
				<Lock aria-label={t('general.locked')} />
			</div>
		);
	};

	const getRecallButton = (text: string, disabled?: boolean): ReactElement => {
		return (
			<CTA tag="button" emphasis="tertiary" disabled={!!disabled} onClick={toggleRecallsLayer}>
				<Text appearance={TokenTextAppearance.copy200}>{text}</Text>
			</CTA>
		);
	};

	const getRecallsVisual = (): ReactElement => {
		switch (recallRequestStatus) {
			case DataRequestState.None:
				return lockedContent();

			case DataRequestState.Available:
				if (numberRecalls === 0) {
					return getRecallButton(t('recallButton.noRecallsFound'), true);
				}
				if (numberRecalls === 1) {
					return getRecallButton(t('recallButton.oneRecallFound'));
				}
				return getRecallButton(`${numberRecalls.toString()} ${t('recallButton.multipleRecallsFound')}`);

			case DataRequestState.Failed:
				return getRecallButton(t('recallButton.noRecallsFound'), true);

			case DataRequestState.Forbidden:
				return lockedContent();

			case DataRequestState.Requested:
				return (
					<div style={{ width: '100%' }}>
						<Skeleton height={24} />
					</div>
				);

			default:
				return lockedContent();
		}
	};

	return (
		<>
			<Text appearance={TokenTextAppearance.headline300}>{t('recallButton.recallsTitle')}</Text>
			<div style={{ marginTop: '16px', display: 'flex', alignItems: 'center', width: '100%' }}>
				<div style={{ marginRight: '16px' }}>
					<UsedCarPrivate aria-hidden={true} />
				</div>
				{getRecallsVisual()}
			</div>
		</>
	);
}

interface Props {
	numberRecalls: number;
	recallRequestStatus: DataRequestState;
	toggleRecallsLayer: () => void;
}
